import React, {useState, useEffect, useRef, useCallback} from 'react';
import State from "../../State";
import ClipLoader from "react-spinners/ClipLoader";
import ImageArchiveService from "./ImageArchiveService";
import {useSearchParams} from "react-router-dom";

function ImageArchive({jsonServer}) {
    const [state] = useState(new State(useState(0)));

    const service = new ImageArchiveService(jsonServer, state);

    const [searchParams, setSearchParams] = useSearchParams();
    const pid = searchParams.get('pid') || '';


    const measuredRef = useCallback(node => {    if (node !== null) {
        state.setWidth(node.clientWidth)
        service.calculatePositions();
    }  }, []);

    const divRef = useRef(null);
    const resizeIframe = () => {
        state.setWidth(divRef.current.clientWidth)
        service.calculatePositions();
    };
    useEffect(() => {
        service.calculatePositions();
        const onResize = () => {
            resizeIframe();
        }

        window.addEventListener("resize", onResize);

        return () => {
            window.removeEventListener("resize", onResize);
        }
    }, []);




    useEffect(() => {
        service.fetchPages(pid);
    }, []);

    if (state.errorMsg) {
        return (<span className="errorMessage">{state.errorMsg}</span>);
    }

    if (state.loading || state.page === null) {
        return (
            <div>
                <ClipLoader loading={state.loading} size={150} />
            </div>
        );
    }

    function mergeRefs(...inputRefs) {
        return (ref) => {
            inputRefs.forEach((inputRef) => {
                if (!inputRef) {
                    return;
                }

                if (typeof inputRef === 'function') {
                    inputRef(ref);
                } else {
                    // eslint-disable-next-line no-param-reassign
                    inputRef.current = ref;
                }
            });
        };
    }

    const image = (filename) => {
        return process.env.PUBLIC_URL + '/media/'+filename;
    }

    return (
        <>
            <div ref={mergeRefs(divRef, measuredRef)}>
                <select value={state.page ? state.page.id : ''} onChange={e => {
                    setSearchParams({'pid': e.target.value});
                    service.setPage(e.target.value)
                }}>
                    {
                        state.pages.map(p => (
                            <option value={p.id}>{p.order === 2012 ? '2007 - 2012' : p.order}</option>
                        ))
                    }
                </select>
                <h1>{state.page.headline}</h1>
                <span>{state.page.preamble}</span>


                {
                    state.page.blocks.map((b) => {
                        const height = (400 * (b.textSnippets.length + (b.textSnippets.length % 2)) / 2) + 'px';
                        return (
                            <>
                                <h2>{b.headline}<br/>
                                    <small>{b.preamble}</small></h2>
                                <div key={b.id} className="gallery" style={{position: 'relative', height: b.height}}>
                                    {
                                        b.textSnippets.map(s => {

                                            return (
                                                <div className="gallery-item"
                                                     style={{position: 'absolute', left: s.left, top: s.top}}>

                                                    <img src={image(s.headline)} alt=""
                                                         onLoad={(e) => service.handleImageLoad(e, s)}/>
                                                    <div className="info">
                                                        {s.content}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                </div>
                            </>
                        )
                    })
                }

            </div>
        </>
    );
}

export default ImageArchive;